var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('swiper-banner',{ref:"banner"}),_c('anchor-list'),_c('about-info'),_c('research-info'),_c('product-info'),_c('overview-info'),_c('news-info'),_c('join-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }